// import React from 'react';
import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import axios from "axios";
import { ApiUrl } from '../Constants/Weburl';
import CustomContainer from './Customsettingscontain';
import CustomInput from './Custominput';
import CustomCard from './CustomCard';
import DeleteModal from './DeleteModal';
import CustomPagination from './Custompagination';
// import CommentsTable from './CommentsTable';
import customTable from './CustomTable';


export default function PostCommentsSection() {
  const { id } = useParams();

  const [activeTab, setActiveTab] = useState("comments"); 

  // ---- Comments state ----
  const [comments, setComments] = useState([]);
  const [commentSearch, setCommentSearch] = useState("");
  const [commentPage, setCommentPage] = useState(1);
  const [commentLimit, setCommentLimit] = useState(10);
  const [commentTotalPages, setCommentTotalPages] = useState(1);

  // ---- Replies state ----
  const [replies, setReplies] = useState([]);
  const [replySearch, setReplySearch] = useState("");
  const [replyPage, setReplyPage] = useState(1);
  const [replyLimit, setReplyLimit] = useState(10);
  const [replyTotalPages, setReplyTotalPages] = useState(1);

  const [openMenu, setOpenMenu] = useState(null);

  //deletemodel 
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteType, setDeleteType] = useState(null);


  useEffect(() => {
    fetchComments();
  }, [id, commentPage, commentLimit, commentSearch]);

  useEffect(() => {
    if (activeTab === "replies") fetchReplies();
  }, [id, activeTab, replyPage, replyLimit, replySearch]);


  const toggleMenu = (itemId) => {
    setOpenMenu((prev) => (prev === itemId ? null : itemId));
  };

  const fetchComments = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const res = await axios.get(
        `${ApiUrl}api/auth/hashtag/post/${id}?page=${commentPage}&limit=${commentLimit}&search=${commentSearch}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setComments(res.data.comments);
      setCommentTotalPages(res.data.totalPages || 1);
    } catch (e) {
      console.log("error fetching comments", e);
    }
  };

  const fetchReplies = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const res = await axios.get(
        `${ApiUrl}api/auth/hashtag/post/${id}?page=${replyPage}&limit=${replyLimit}&search=${replySearch}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // flatten every comment's reply_comments into one list
      const flatReplies = (res.data.comments || []).flatMap(
        (c) => c.reply_comments || []
      );
      setReplies(flatReplies);
      setReplyTotalPages(res.data.totalPages || 1);
    } catch (e) {
      console.log("error fetching replies", e);
    }
  };

  const getImageUrl = (img) => {
    if (!img) return "";
    if (img.startsWith("http")) return img;
    return `${ApiUrl}${img.replace("\\", "/")}`;
  };


  // Open delete confirmation modal
  const handleDeleteClick = (id, type) => {
    setDeleteId(id);
    setDeleteType(type);
    setShowDeleteModal(true);
  };


  const confirmDelete = async () => {
    if (!deleteId || !deleteType) return;

    try {
      const token = localStorage.getItem("adminToken");

      if (deleteType === "comment") {
        await axios.delete(
          `${ApiUrl}api/auth/hashtag/comment/${deleteId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setComments((prev) =>
          prev.filter((c) => c.id !== deleteId)
        );
      } else if (deleteType === "reply") {
        await axios.delete(
          `${ApiUrl}api/auth/hashtag/replycomment/${deleteId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setReplies((prev) =>
          prev.filter((r) => r.id !== deleteId)
        );
      }

      setShowDeleteModal(false);
      setDeleteId(null);
      setDeleteType(null);
    } catch (error) {
      console.log("Delete error:", error);

      alert(
        error.response?.data?.message ||
        "Something went wrong"
      );
    }
  };

  // Close delete modal
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteId(null);
    setDeleteType(null);
  };


  // const deleteReplyComment = async (replyId) => {
  //   try {
  //     const token = localStorage.getItem("adminToken");
  //     await axios.delete(`${ApiUrl}api/auth/hashtag/replycomment/${replyId}`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     setReplies((prev) => prev.filter((r) => r.id !== replyId));
  //   } catch (e) {
  //     console.log("Delete reply error", e);
  //   }
  // };

  const formatDate = (d) =>
    new Date(d).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  // shared pagination bits, driven by whichever tab is active
  const page = activeTab === "comments" ? commentPage : replyPage;
  const setPage = activeTab === "comments" ? setCommentPage : setReplyPage;
  const totalPages =
    activeTab === "comments" ? commentTotalPages : replyTotalPages;
  const limit = activeTab === "comments" ? commentLimit : replyLimit;
  const setLimit = activeTab === "comments" ? setCommentLimit : setReplyLimit;
  const search = activeTab === "comments" ? commentSearch : replySearch;
  const setSearch = activeTab === "comments" ? setCommentSearch : setReplySearch;
  const listLength = activeTab === "comments" ? comments.length : replies.length;

  return (
    <>
      <CustomCard className="cw-card">
        {/* Tabs */}
        <div className="cw-tabs">
          <div
            className={`cw-tab ${activeTab === "comments" ? "active" : ""}`}
            onClick={() => setActiveTab("comments")}
          >
            Comments ({comments.length})
          </div>
          <div
            className={`cw-tab ${activeTab === "replies" ? "active" : ""}`}
            onClick={() => setActiveTab("replies")}
          >
            Replies ({replies.length})
          </div>
        </div>

        {/* Controls: entries + search (kept, write-box removed) */}
        <div className="cw-controls">
          <div className="cw-left">
            Show
            <select
              className="rr-select"
              value={limit}
              onChange={(e) => {
                setLimit(Number(e.target.value));
                setPage(1);
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
            entries
          </div>

          <div className="rr-right">
            <CustomInput
              type="text"
              className="rr-search"
              value={search}
              placeholder="Search Comments"
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
            />
          </div>
        </div>

        {/* List */}
        <div className="cw-list">
          {activeTab === "comments" &&
          (comments.length > 0 ? (
            comments.map((item) => (
              <div className="cw-item" key={item.id}>
                <img
                  className="cw-avatar"
                  src={getImageUrl(item?.user?.avatar)}
                  alt=""
                />
                <div className="cw-body">
                  <div className="cw-header-row">
                    <strong>{item?.user?.username}</strong>
                    <span className="cw-time">
                      {formatDate(item.createdAt)}
                    </span>
                  </div>

                  <div className="cw-bubble">{item.comments}</div>

                  <div className="cw-actions">
                    <span>
                      <i className="bi bi-heart"></i>{" "}
                      {item?.like_comments?.length || 0} Like
                    </span>
                    <span>
                      {/* <i class="bi bi-wechat"></i>{" "} */}
                      <i class="bi bi-chat-dots"></i>{" "}
                      {item?.reply_comments?.length || 0} Reply
                    </span>
                    <span
                      className="cw-delete"
                      // onClick={() => deleteComment(item.id)}
                      onClick={() => handleDeleteClick(item.id, "comment")}
                    >
                      <i className="bi bi-trash"></i>
                    </span>
                  </div>
                </div>
              </div>
            )) 
          ) : ( 
             <div className="cw-no-data">No data found</div>
          )
            )}

          {activeTab === "replies" &&
            (replies.length > 0 ? (
              replies.map((item) => (
                <div className="cw-item" key={item.id}>
                  <img
                    className="cw-avatar"
                    src={getImageUrl(item?.user?.avatar)}
                    alt=""
                  />
                  <div className="cw-body">
                    <div className="cw-header-row">
                      <strong>{item?.user?.username}</strong>
                      <span className="cw-time">
                        {formatDate(item.createdAt)}
                      </span>
                    </div>

                    <div className="cw-bubble">{item.replytext}</div>

                    <div className="cw-actions">
                      <span
                        className="cw-delete"
                        // onClick={() => deleteReplyComment(item.id)}
                        onClick={() => handleDeleteClick(item.id, "reply")}
                      >
                        <i className="bi bi-trash"></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="cw-no-data">No data found</div>
            ))}
        </div>

        {/* Footer */}
        <div className="rr-footer">
          <span>
            Showing 1 to {listLength} of {listLength} entries
          </span>
          <div className="rr-pagination">
            <span
              className="rr-page-arrow"
              onClick={() => page > 1 && setPage(page - 1)}
            >
              &lt;
            </span>
            {Array.from({ length: totalPages || 0 }).map((_, i) => (
              <span
                key={i}
                className={`rr-page ${page === i + 1 ? "active" : ""}`}
                onClick={() => setPage(i + 1)}
              >
                {i + 1}
              </span>
            ))}
            <span
              className="rr-page-arrow"
              onClick={() => page < totalPages && setPage(page + 1)}
            >
              &gt;
            </span>
          </div>
        </div>
      </CustomCard>
      <DeleteModal
        show={showDeleteModal}
        close={closeDeleteModal}
        onDelete={confirmDelete}
        title={
          deleteType === "reply"
            ? "Delete Reply"
            : "Delete Comment"
        }
        message={
          deleteType === "reply"
            ? "Are you sure you want to delete this reply?"
            : "Are you sure you want to delete this comment?"
        }

      />
    </>


  );
}
